const baseUrl = process.env.REACT_APP_API_URL || "https://ukezhavamatrimony.com";
export default baseUrl;

